export default __webpack_public_path__ + "static/media/rueda-de-networking.cd0c7a30.jpeg";